import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';

import styles from './FooterMini.module.scss';

export const FooterMini = observer(
  React.forwardRef<
    HTMLDivElement,
    Omit<React.ComponentPropsWithRef<'footer'>, 'children'>
  >((props, ref) => {
    const { t } = useTranslation();

    return (
      <footer
        {...props}
        ref={ref}
        className={styles.footer}
        data-company={company.name}
      >
        <div className="content-layout">
          <div className={styles.simple_template}>
            <div className={styles.footer_copyright}>
              <h3>&copy; {t('phrases:generalTrading')}</h3>
            </div>

            <div className={styles.legals_info}>
              <Link
                data-link="footer-legals"
                to={'/legals'}
                state={{ source: 'home' }}
                className={styles.footer_legals}
              >
                {t('termsAndConditions')}
              </Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }),
);
